import React from 'react';

const TicketPricingTable = ({ pricingData }) => {
  return (
    <div className="ticket-pricing">
      <table className="ticket-pricing__table">
        <thead>
          <tr>
            <th></th>
            <th>VIP*</th>
            <th>A</th>
            <th>B</th>
          </tr>
        </thead>
        <tbody>
          {pricingData.map((item) => (
            <tr key={item.id}>
              <td>{item.TicketCategory}</td>
              <td>{item.PriceVip ? `€${item.PriceVip.toFixed(2)}` : '-'}</td>
              <td>{item.PriceA ? `€${item.PriceA.toFixed(2)}` : '-'}</td>
              <td>{item.PriceB ? `€${item.PriceB.toFixed(2)}` : '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TicketPricingTable;